import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonEn from "./en/common.json";
import commonFr from "./fr/common.json";
import mixerEn from "./en/mixer.json";
import mixerFr from "./fr/mixer.json";
import validationEn from "./en/validation.json";
import validationFr from "./fr/validation.json";
import micrositeEn from "./en/microsite.json";
import micrositeFr from "./fr/microsite.json";
import userAppEn from "./en/user_app.json";
import userAppFr from "./fr/user_app.json";

const resources = {
  en: {
    common: commonEn,
    mixer: mixerEn,
    validation: validationEn,
    microsite: micrositeEn,
    user_app: userAppEn,
  },
  fr: {
    common: commonFr,
    mixer: mixerFr,
    validation: validationFr,
    microsite: micrositeFr,
    user_app: userAppFr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  defaultNS: "common",
  fallbackLng: "en",
  compatibilityJSON: "v3",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
